export default {
  common: {
    email: '信箱',
    phone: '電話',
    phoneNumber: '電話號碼',
    countrySelect: '選擇國家',
    countryUnmodifiedNote: '註冊後國家不可修改',
    next: '下一步',
    back: '返回',
    attention: '注意',
    cancel: '取消',
    confirm: '確認',
    modify: '修改',
    ignore: '忽略',
    firstName: '名字',
    middleName: '中間名',
    lastName: '姓氏',
    gender: '性別',
    male: '男',
    female: '女',
    birthday: '生日',
    graphicCode: '圖形驗證碼',
    emailCode: '信箱驗證碼',
    smsCode: '簡訊驗證碼',
    smsVerificationCode: '簡訊驗證碼',
    bind: '綁定',
    send: '傳送',
    resend: '重新發送',
    address: '地址',
    done: '完成',
    systemMessage: '系統訊息',
    setting: '設定',
    submit: '提交',
    language: '語言',
    edit: '編輯',
    delete: '刪除'
  },
  account: {
    account: '帳戶',
    nickname: '暱稱',
    id: 'ID',
    basicInfo: '基礎等級',
    placeholder: '請輸入',
    completed: '已完成',
    semiInfo: '半驗證',
    fullyInfo: '全驗證',
    basicTab: '基礎',
    advancedTab: '進階',
    linkedAccount: '關聯提現帳戶',
    accountSecurity: 'MetWallet帳戶及安全',
    logout: '退出',
    semiToast: '請完成基礎等級驗證',
    fullyToast: '請完成基礎等級\n及半驗證',
    quickLoginTitle: '快速登入',
    cancelQuickLogin: '確定要停用快速登入嗎？'
  },
  accountSecurity: {
    title: '帳戶及安全',
    payPwd: '支付密碼',
    loginPwd: '登入密碼',
    changeEmail: '修改信箱',
    changePhone: '修改手機號',
    changePayPwd: '修改支付密碼',
    changeLoginPwd: '修改登入密碼',
    bindEmail: '綁定信箱',
    bindEmailNote: '透過郵箱驗證進行綁定',
    bindEmailPlaceholder: '輸入您要綁定的信箱',
    smsBindNote: '透過簡訊驗證進行綁定',
    bindPhone: '綁定手機號',
    smsAuthentication: '簡訊驗證',
    emailAuthentication: '信箱驗證',
    phoneVerificationNote: '請先通過當前手機號碼驗證',
    bindPhonePlaceholder: '輸入您要綁定的手機號',
    verificationWrongToast: '請檢查您的驗證碼',
    phoneNumberEmptyToast: '請填寫手機號碼',
    verificationCodeEmptyToast: '請填寫驗證碼',
    wrongCodeToast: '驗證碼錯誤',
    changeNote: '請透過驗證進行修改。',
    newEmailVerification: '新郵箱驗證',
    newEmailPlaceholder: '輸入您的新信箱',
    change: '修改',
    emailLowercaseToast: '郵箱必須為小寫。',
    newEmailEmptyToast: '請填寫新信箱',
    changeSuccessToast: '修改成功',
    phonePlaceholder: '輸入手機',
    currentEmail: '目前電子郵件',
    passCurrentEmailVerificationFirst: '先透過目前電子郵件驗證',
    currentEmailVerification: '目前電子郵件驗證',
    smsVerification: '簡訊驗證',
    currentPhoneNumber: '目前手機號',
    currentPhoneVerification: '目前手機驗證',
    currentEmailAddress: '目前郵箱地址',
    phoneVerification: '電話驗證',
    enterVerificationCode: '輸入驗證碼',
    newPhoneNumber: '新手機號碼',
    newEmail: '新電子郵件'
  },
  withdrawAccount: {
    selectAccountType: '選擇帳戶類型',
    noBasicLevelVerificationDialog: '綁定提現方式前，請先完成基礎等級驗證。',
    bindNote: '請填寫正確的帳戶訊息，否則您的提現將會受到影響。',
    bindBankAccount: '綁定銀行帳戶',
    bindMobileMoneyAccount: '綁定行動貨幣帳戶',
    fieldEmptyToast: '{0}為必填項',
    fieldLengthToast: '{0}必須至少包含{1}個字符',
    bindBankRepeatToast: '請勿重複綁定同一個銀行帳戶！',
    accountName: '帳戶名稱',
    ifscCode: 'IFSC程式碼',
    accountEmptyToast: '帳戶為必填項',
    accountNameEmptyToast: '帳戶名稱為必填項',
    phoneEmptyToast: '電話為必填項',
    emailEmptyToast: '信箱為必填項',
    ifscCodeEmptyToast: 'IFSC代碼為必填項',
    ifscCodeLengthToast: 'IFSC代碼必須為11位數字',
    bindIMPSRepeatToast: '請勿重複綁定同一個IMPS帳戶！',
    bindNote2: '請填寫您正確的TRC-20地址，地址錯誤將導致款項遺失，對此我們不承擔任何責任。',
    usdtAddress: 'USDT位址(TRC-20):',
    minimumLimit: '每筆提現最低金額：$10',
    usdtFee: '費用：以實際費用為準',
    registerGcash: '如果您沒有Gcash帳戶，請點擊此處註冊。',
    registerEpay: '如果您沒有Epay帳戶，請點選此處註冊。',
    bindThirdPartyTitle: '綁定{0}帳戶',
    wrongAccountToast: '帳戶錯誤',
    accountFormatToast: '帳戶格式不正確',
    bindThirdPartyFailedToast: '{0}綁定失敗',
    queryFailedToast: '查詢失敗。',
    editFailedToast: '編輯失敗。',
    add: '添加',
    confirmEditDialog: '您確定要編輯帳號{0}嗎？',
    payPwdRequireDialog: '新增帳戶前，請設定6位付款密碼。',
    unbindFailedToast: '解綁失敗',
    cashOutSuccessNote: '預計抵達時間：7 個工作天內',
    requestSubmitted: '提現申請已提交',
    amountLimitToast1: '提現金額必須≥$40.00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: '提現金額必須≥${0}.00',
    // eslint-disable-next-line no-template-curly-in-string
    recommendAmountNote: '提示：提現前累計金額到${0}可有效節省手續費',
    amountNotEnoughToast: '提現金額不足',
    exceedingLimitToast1: '今日提現金額已達上限',
    exceedingLimitToast2: '今日提現金額已達上限，是否要完成高級認證以提升限額？',
    restrictedCountriesPayPalAccountToast: '請勿使用受限制國家的PayPal帳戶，否則會導致您的Arripay被凍結',
    withdrawMinimumToast: '每筆提現最低金額：$40',
    bankNotAvailableToast: '該銀行已不再可用，請綁定其他銀行',
    usdtAccountInvalidToast: '此USDT帳戶無法提現，請使用新帳戶提現。',
    noPayPwdToast: '提現前請設定6位付款密碼',
    editBankAccount: '編輯銀行帳戶',
    accountPlaceholder: '輸入您的帳戶',
    trc20Placeholder: '輸入TRC-20位址',
    accountRepeatToast: '與目前密碼相同。',
    unbindBankCardConfirmDialog: '確定解綁銀行卡{0}嗎？',
    unbindMobileMoneyAccountConfirmDialog: '確定解綁行動錢包帳戶{0}嗎？',
    unbindAccountConfirmDialog: '確定解綁定帳戶{0}嗎？',
    availableBalance: '可用餘額{0}',
    estimatedFee: '預估費用',
    submitFailToast: '提交失敗',
    disabledMethodToast: '該管道暫時無法使用',
    channelUnavailableTitle: '管道不可用',
    channelUnavailableNote: '該提現管道暫時無法使用，請嘗試其他方式。',
    channelUnavailableOk: '確定',
    bankTransferUnavailableTitle: '銀行轉帳不可用',
    bankTransferUnavailableNote: '您的帳戶目前無法使用銀行轉帳。請使用 Epay 提現。',
    channelMaintenanceTitle: '管道維護中',
    channelMaintenanceNote: '該提現管道正在維護中，請嘗試其他方式。',
    bankInfoUpdateTitle: '請更新銀行資訊',
    bankInfoUpdateNote: '因銀行政策調整，請更新您的銀行資訊後繼續。',
    bindEpay: '綁定 Epay',
    useEpay: '使用 Epay',
    iMPSMaxLimitToast: '在該通路單筆最大提現額度為$260',
    linkedAccount: '已新增帳戶',
    otherAccounts: '其他可添加帳戶',
    withdrawTo: '轉出至',
    withdrawAmount: '转出金额',
    withdrawable: '可提現的',
    documentIdToast: '身分證字號碼只能包含數字',
    noAvailableMethodNote: '無可用的提現方式',
    channelFee: 'Fee：{0}',
    recommended: '推薦'
  },
  paymentCode: {
    changePayPwd: '修改支付密碼',
    setPayPwd: '設定支付密碼',
    setPayPwdNote: '請設定6位支付密碼',
    reenterPayPwdNote: '重新輸入',
    verificationNote: '請經過驗證後進行設置',
    verifyToSetPayPwd: '驗證以設置支付密碼。',
    emailVerification: '信箱驗證',
    inconsistentPasswordToast: '密碼不一致',
    payPwdNote: '請輸入支付密碼',
    payPwdFormatToast: '支付密碼為6位數字',
    payPwdWrongToast: '支付密碼錯誤',
    payPwdVerificationFailToast: '支付密碼驗證失敗！',
    successToast: '設定\n成功'
  },
  authorize: {
    requirement: '{0}需要取得您MetWallet{1}的以下信息，才能為您提供相關服務。如暱稱、頭像、性別等。',
    authorize: '授權',
    switchAccount: '切換帳戶',
    goToMetWallet: '前往MetWallet',
    notMatchTips: '操作失敗。您只能使用綁定的MetWallet帳號啟用快速登入'
  },
  basicLevel: {
    namePlaceholder: '無符號、數字',
    verification: '驗證',
    whatsAvailable: '可用內容',
    cashOut: '提現',
    withdrawTitle: '提現',
    withdrawLimit: '$50/天',
    fillInfoHint: '填寫資訊以便提現',
    identityVerification: '身份驗證',
    withdrawalAccountStep: '提現帳戶',
    nameMatchNote: '請確保姓名與銀行卡一致，否則提現將失敗。',
    nameFieldPlaceholder: '姓名',
    birthdayPlaceholder: '出生日期',
    addressPlaceholder: '請輸入地址',
    emailRegisteredNote: '該郵箱已被註冊，請更換一個。',
    basicLevelNote: '請填寫真實個人資訊，提交後不可修改。資訊錯誤可能導致提現失敗。',
    fieldEmptyToast: '請填寫所有必填欄位。',
    successToast: '保存\n成功',
    failToast: '保存失敗',
    confirmDialog: '請確保輸入真實的個人資料。錯誤資料可能導致提現失敗。',
    birthdayFormatToast: '生日字段格式不正確',
    verificationCodeError: '驗證碼錯誤',
    verificationCodeEmpty: '驗證碼為空',
    noEmailCodeToast: '請取得郵箱驗證碼',
    confirmInfoTitle: '確認資訊',
    confirmInfoWarning: '*姓名必須與銀行卡完全一致，否則可能導致提現失敗。提交後不可修改。',
    saveCountdown: '保存（{0}秒）',
    saveInfo: '保存',
    checkDialogTitle: '檢查您的資料',
    checkDialogContent: '為成功提現，請檢查您的資料。錯誤資料可能導致提現失敗。',
    check: '檢查'
  },
  semiVerified: {
    uploadPhotoId: '上傳帶照片的身份證件',
    photoId: '附照片的身份證件',
    resubmit: '重新提交',
    limit: '每日5000美元',
    uploading: '上傳中...',
    notUploadProofToast: '請上傳身分證件證明'
  },
  fullyVerified: {
    frontOfId: '證件正面',
    backOfId: '證件背面',
    uploadIdFront: '上傳證件正面',
    uploadIdBack: '上傳證件背面',
    withdrawDailyHint: '填寫資訊以便提現 > {0} /天',
    notUploadIdToast: '請上傳證件正反面',
    proofTitle: '居住證明文件',
    acceptableProof: '可接受的居住證明是：',
    acceptableProof1: '銀行帳戶對帳單',
    acceptableProof2: '公用事業帳單（電費、水費、網路費等）',
    acceptableProof3: '政府簽發的文件（稅務報表、居住證明等）',
    unacceptableProof: '我們不能接受您提交的身份證件上的地址作為有效的居住證明。',
    limit: '每天 10,000 美元',
    notUploadToast: '請上傳居住證明文件',
    incorrectFormatToast: '請上傳 jpg/png/jpeg 圖片'
  },
  loginAndRegister: {
    pwd: '密碼',
    lastLogin: '上次登入',
    moreOptions: '更多選項',
    agreeCheckboxContent: '同意{0}和{1}',
    userAgreement: '使用者協定',
    privacyPolicy: '隱私權政策',
    notAgreeToast: '同意使用者協議和隱私權政策',
    forgotPassword: '忘記密碼',
    linkedMail: '關聯信箱',
    verificationCode: '驗證碼',
    newPwd: '新密碼',
    repeatPwd: '重複密碼',
    confirmPwd: '確認密碼',
    noLinkedEmailToast: '您的帳戶沒有關聯信箱',
    unregisteredToast: '此號碼未註冊',
    pwdFormatToast: '密碼格式錯誤',
    resetSuccessToast: '重置\n成功',
    pwdNotMatchToast: '密碼兩次不匹配',
    emailFormatToast: '電子郵件格式錯誤',
    phoneNumberFormatToast: '電話號碼格式錯誤',
    invalidAreaCodeToast: '無效的區號',
    login: '登入',
    pwdLogin: '透過密碼登入',
    emailCodeLogin: '透過電子郵件驗證碼登入',
    smsLogin: '透過簡訊登入',
    verifyEmail: '驗證電子郵件',
    verifyPhone: '驗證電話',
    accountDangerDialog: '您的帳戶已被偵測到有風險。請重新驗證您的帳戶，否則您的帳戶將無法繼續使用。',
    sendEmailCodeDialog: '我們已將驗證碼傳送到您的{0}電子郵件。請輸入驗證碼。',
    sendSmsCodeDialog: '我們已將驗證碼發送到您的{0}電話。請輸入驗證碼。',
    graphicCodeEmptyToast: '請輸入圖形驗證碼',
    countryUnselectToast: '請先選擇您所在的國家/地區',
    unsupportedLoginTypeToast: '不支援的登入類型',
    pwdWrongLimitOverDialog: '密碼輸入錯誤3次。請使用簡訊驗證碼登入。',
    loginFailedToast: '登入失敗',
    signIn: '登入',
    pwdPlaceholder: '輸入密碼',
    pwdNote: '輸入8-16位字母和數字組合',
    reenterPwdPlaceholder: '重新輸入密碼',
    reenterPwdNote: '請重新輸入密碼',
    createAccount: '建立帳戶',
    chooseCountryNote: '請選擇國家',
    pwdInconsistentToast: '與您之前輸入的密碼不一樣',
    createSuccessToast: '創建\n成功',
    registerFailToast: '註冊失敗',
    userNotExistToast: '用戶不存在',
    phoneIncorrectToast: '請檢查手機',
    userExistToast: '用戶已存在',
    countryCodeRepeatToast: '請勿重複輸入國家碼！',
    logoutDialog: '確定退出嗎？',
    pwdRequirement: '密碼必須為8到16個字符，包含字母和數字',
    signup: '註冊',
    registerSuccessToast: '註冊\n成功',
    oldPwdErrorToast: '請檢查舊密碼'
  },
  checkUserInfo: {
    title: '管理中心',
    emptyInfoNote: '無目前帳戶資訊，請檢查您需要驗證的MetWallet帳戶。',
    infoNote: '這是您的驗證資訊。',
    lastSuccessWithdrawal: '最近一次成功提現',
    copyBtn: '複製',
    successToast: '複製成功！',
    failToast: '複製失敗！'
  },
  country: {
    title: '選擇地區',
    popular: '熱門'
  },
  documentDetails: {
    title: '文件詳情',
    contract: '合約',
    goToSign: '去簽字',
    download: '下載',
    upload: '上傳',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., 僅限檔案。',
    contentEmptyToast: '請輸入內容',
    placeOfBirth: '出生地',
    occupation: '職業',
    fileForm: '(文件形式)',
    proofOfAddress: '英文住址證明',
    residenceDoc: '居住文件',
    textForm: '(文本形式)',
    contractAgent: '合約代理人',
    contractPayslip: '合約薪資單',
    uncompletedToast: '請填寫後提交',
    successToast: '提交成功',
    undefinedFileTypeToast: '未定義檔上傳類型',
    uploadFailToast: '上傳失敗'
  },
  filters: {
    amount: '數量',
    filter: '篩選條件',
    time: '時間',
    reset: '重置',
    timePickerTitle: '選擇{0}時間',
    start: '開始',
    end: '結束',
    maximum: '最大值',
    minimum: '最小值'
  },
  home: {
    balance: '餘額',
    transactions: '交易',
    availableBalance: '可用餘額',
    noWithdrawalMethodToast: '至少需要一種提現方式。',
    linkAccount: '連結帳戶',
    all: '全部',
    cashIn: '現金存入',
    loading: '載入中...',
    noMore: '沒有更多交易',
    reload: '加載失敗，點擊重新加載',
    receivedFrom: '收到的款項',
    transferredTo: '轉帳至',
    fee: '轉帳費用',
    myEmail: '我的電子郵件',
    myPhone: '我的電話',
    invalidBasicLevelDialog:
      '由於您的姓名欄位中包含符號、空格或數字，因此無法從帳戶中提款。請再次填寫基本資料（確保姓名中不包含符號、空格或數字，如果您沒有姓氏或中間名，請留空。）',
    lackLastNameDialog: '您的姓氏未填寫，這將妨礙您的提款。',
    fillIn: '填寫',
    viewDetails: '看詳情',
    docReviewingDialogTitle: '請等待文件通過。',
    docReviewingDialogContent:
      '您已提交文件，但在文件通過之前您無法使用MetWallet。 <br>官方工作人員將很快處理，請等待一段時間。',
    docPassedDialog: '您提交的文件已通過。 <br>您現在可以正常使用MetWallet。',
    docUnqualifiedDialog: '您提交的文件不合格。 <br>請提交合格的文件。',
    goToSubmit: '去提交',
    uncompletedDialog: '您必須完成它才能正常使用MetWallet',
    useMetWalletNormallyAfterPassed: '文件通過後，您即可正常使用MetWallet。',
    requireSemiVerifiedDialog: '{0}，根據銀行的要求，您必須在48小時內完成半驗證部分才能成功提款。',
    goToVerify: '去驗證',
    emailInvalidDialog: '{0}，您的電子郵件地址與他人相同。為了保護您的隱私，請盡快輸入您自己的電子郵件地址。',
    later: '稍後',
    transferRequireSemiVerifiedDialog: '轉帳前請完成半驗證。',
    modifyBtnText: '修改我的資訊',
    unmodifiedTitle: '無法修改',
    unmodifiedContent: '您有一個提現訂單正在處理中，現在無法修改資料。'
  },
  signing: {
    signature: '簽名',
    date: '日期',
    employeeName: '員工姓名',
    designation: '職位',
    month: '月',
    year: '年',
    earnings: '收入',
    deductions: '扣除額',
    basic: '基本及 DA(USD)',
    totalAddition: '總增加額',
    totalDeduction: '總扣除額',
    salary: '淨工資',
    refNo: '參考編號',
    paymentTransferDate: '付款轉帳日期',
    nameOfBank: '銀行名稱',
    signatureOfEmployee: '員工簽名',
    director: '主管',
    signNote: '請簽名',
    preview: '預覽',
    clear: '清除',
    save: '儲存',
    noSignatureToast: '沒有簽名則無法儲存。',
    fieldEmptyToast: '請填寫所有資料。'
  },
  transactionDetail: {
    title: '交易詳情',
    status: '狀態',
    pending: '待處理',
    completed: '已完成',
    success: '成功',
    failed: '失敗',
    cancelled: '已取消',
    onHold: '暫停',
    reason: '狀態原因',
    description: '說明',
    creationDate: '建立日期',
    lastStatusDate: '最後狀態日期',
    requestedAmount: '請求金額',
    receiveAmount: '收到金額',
    transferAmount: '轉帳金額',
    amountToPay: '應付金額',
    transferFee: '轉帳費',
    processingFee: '手續費',
    method: '方法',
    country: '國家',
    name: '姓名',
    bankPendingText: '處於最終銀行審核中',
    pendingText: '處於{0}審核中',
    chametSalary: '代理代提',
    userSalary: '主播提現',
    comm: '代理費',
    gemgalaSalary: 'Gemgala代理費'
  },
  transfer: {
    title: '至 MetWallet 帳戶',
    noPayPwdDialog: '轉帳前請設定 6 位付款密碼。',
    records: '記錄',
    cashInOut: '存入{0}，提出{1}',
    transfer: '轉帳',
    fee: '費用',
    remark: '備註',
    transferTo: '轉帳至{0}',
    remarkPlaceholder: '新增轉帳備註（100個字元以內）',
    firstNameNote: '請輸入對方姓名',
    sendingAmount: '匯款金額',
    receivingAmount: '收款金額',
    transferNow: '立即轉帳',
    noBalanceToast: '轉帳金額大於餘額',
    amountTooLittleToast: '轉帳金額不能小於$10'
  },
  bankData: {
    beneficiaryName: '收款人姓名',
    beneficiaryNamePlaceholder: '輸入姓名',
    beneficiaryLastname: '受益人姓氏',
    beneficiaryLastnamePlaceholder: '輸入姓氏',
    bankCode: '銀行代碼',
    bankCodePlaceholder: '選擇銀行代碼',
    bankIFSCCode: '銀行 IFSC 代碼',
    bankIFSCCodePlaceholder: '輸入銀行 IFSC',
    bankAccount: '銀行帳戶',
    bankAccountPlaceholder: '輸入銀行帳戶',
    email: '電子郵件',
    emailPlaceholder: '輸入電子郵件',
    phoneNumber: '電話號碼',
    phoneNumberPlaceholder: '輸入電話號碼',
    address: '地址',
    addressPlaceholder: '輸入地址',
    city: '城市',
    cityPlaceholder: '輸入城市',
    state: '狀態',
    statePlaceholder: '輸入狀態',
    postCode: '郵遞區號',
    postCodePlaceholder: '輸入郵遞區號',
    documentId: '文件編號',
    documentIdPlaceholder: '輸入文檔 ID',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: '文件類型',
    documentTypePlaceholder: '選擇文檔類型',
    accountType: '帳戶類型',
    accountTypePlaceholder: '選擇帳戶類型',
    cpfcnpjPlaceholder: '輸入 CPFCNPJ',
    bankBranch: '銀行分行',
    bankBranchPlaceholder: '進入銀行分行',
    ribOfBankAccount: '銀行帳戶RIB',
    bankName: '銀行名稱',
    bankNamePlaceholder: '輸入銀行名稱',
    bicCode: 'BIC代碼',
    bicCodePlaceholder: '輸入 BIC 代碼',
    ibanPlaceholder: '輸入國際銀行帳號',
    bankSwift: '銀行環球銀行間銀行',
    bankSwiftPlaceholder: '輸入銀行 Swift',
    name: '姓名',
    documentCountry: '文件國家',
    documentCountryPlaceholder: '選擇文件國家/地區',
    issueDate: '文件簽發日期',
    issueDatePlaceholder: '選擇發行日期',
    expireDate: '文件到期日',
    expireDatePlaceholder: '選擇到期日',
    bankBranchName: '銀行分行名稱',
    bankBranchNamePlaceholder: '輸入分行名稱',
    branchPlaceholder: '進入分行',
    gender: '性別',
    genderPlaceholder: '選擇性別',
    birthday: '生日',
    birthdayPlaceholder: '選擇生日',
    phone: '電話',
    bankAddress: '銀行地址',
    bankAddressPlaceholder: '輸入銀行地址',
    bankAccountName: '銀行帳戶名稱',
    bankAccountNamePlaceholder: '輸入銀行帳戶名稱',
    province: '省',
    provincePlaceholder: '輸入省份',
    postalCode: '郵遞區號',
    postalCodePlaceholder: '輸入郵遞區號',
    savingsAccount: '儲蓄帳戶',
    abaRoutingNumber: 'ABA 路由號碼',
    englandBankAccount: '英國銀行帳戶',
    bankBranch2: '銀行分行',
    bankBranch2Placeholder: '僅當銀行是桑坦德銀行時',
    paternalName: '父親姓名',
    paternalNamePlaceholder: '輸入父親姓名',
    passportIdNumber: '護照號碼',
    bankNamePlaceholder2: '選擇銀行名稱',
    areaCode: '手機區號',
    phoneNumberNoAreaCode: '手機號碼 (不含區號)',
    idType: '證件類型',
    idNo: '證件號碼',
    idIssueDate: '證件簽發日期',
    idExpireDate: '證件有效日期',
    ibanStyleToast: '請輸入以“SA”開頭，長度為24個字元的內容'
  },
  rechargeAndTransfer: {
    transfer_limit_1: '你只能轉帳給主鑽石銷售代理',
    search: '搜尋',
    history: '歷史轉帳用戶',
    confirm_content: '你確認要轉帳{0}給{1}？',
    success_content: '{0}已轉帳至{1}',
    purchase: '購買',
    purchase_success: '你已成功購買{0}',
    insufficient_balance: '餘額不足',
    purchase_diamond: '購買鑽石',
    transfer_limit_2: '轉帳金額需介於$10到$30,000',
    no_data: '無數據',
    invalid_number: '請輸入有效數字',
    under_limit: '轉帳金額需不低於$10',
    over_limit: '轉帳金額需低於$30,000'
  },
  redesign: {
    emailPlaceholder: '輸入郵件地址',
    retrievePwd: '找回密碼',
    resetPwd: '重設密碼',
    newPwdPlaceholder: '輸入新密碼',
    reenterNewPwdPlaceholder: '重新輸入新密碼',
    reenterPayPwdPlaceholder: '請重新輸入支付密碼',
    sendToPhone: '驗證碼已發送至您的手機',
    sendToWhatsapp: '驗證碼已發送至您的 WhatsApp',
    sendToEmail: '驗證碼已寄至您的信箱',
    invalidCode: '驗證碼無效',
    userId: '使用者 ID',
    other: '其他',
    transactionRecord: '交易記錄',
    bankCardInfo: '金融卡帳戶',
    withdrawInfo: '提現帳戶',
    toFillIn: '未填寫',
    walletInfo: '錢包帳戶資訊',
    toComplete: '待完善',
    verifyGuide: '完成錢包帳戶資訊以獲得更多提現資格',
    verifyNote: '完成以下資訊解鎖每日提領 {0} 資格',
    verifyCompletedNote: '資訊填寫完成，取得每日 {0} 提現資格',
    continueBtnText: '繼續填寫',
    submitInfo: '提交訊息',
    transferAmount: '轉出金額',
    newEmailVerify: '新郵箱驗證',
    verifyCodePlaceholder: '輸入驗證碼',
    emailIncorrectToast: '請填寫正確的信箱地址',
    newPhone: '新手機號碼',
    accountAdded: '已新增帳戶資訊',
    accountToAdd: '其他可添加帳戶',
    edit: '編輯',
    enterPayPwd: '輸入支付密碼',
    deleteBtnText: '刪除',
    transferTo: '轉出至',
    withdrawable: '可提現的',
    goSet: '去設定',
    goModify: '去修改'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/tw.js